module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"118 12 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M126 24l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L126 12l2.351 4.764 5.257.764-3.804 3.708.898 5.236z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star.svg
// module id = 239
// module chunks = 0